import styled, { css } from 'styled-components';
import { prop } from 'ramda';

import { Color, Spacing, FontWeight, Layer, Media } from '../../theme';
import { styleWhenTrue } from '../../utils';

export const Container = styled.div<{alignEnd?: boolean}>`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${Color.white};
  border-bottom: 1px solid ${Color.primary};
  padding: 0 ${Spacing.DesktopWide};
  position: relative;
  color: ${Color.primary};
  font-size: 14px;
  font-weight: ${FontWeight.Light};
  letter-spacing: 0;
  line-height: 18px;
  z-index: ${Layer.AlertBar};
  width: calc(100% - 2 * ${Spacing.DesktopWide});
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.7s ease-in-out 0s;
  flex-shrink: 0;
  max-height: 200px;
  ${Media.desktop`
    padding: 0 ${Spacing.Desktop};
    width: calc(100% - 2 * ${Spacing.Desktop});
  `}
  ${Media.tablet`
    padding: 0 ${Spacing.Tablet} 0;
    width: calc(100% - 2 * ${Spacing.Tablet});
  `}
  ${styleWhenTrue(prop('alignEnd'), css`
    justify-content: flex-end;
  `)}
`;

export const CloseIcon = styled.img``;

export const CloseButton = styled.button`
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
`;

export const TextContent = styled.div`
  width: 100%;
  padding: 16px 0;
  text-align: left;
  ${styleWhenTrue(prop('alignCenter'), css`
    text-align: center;
  `)}
  strong {
    font-weight: ${FontWeight.Bold};
  }
  a {
    color: ${Color.primary};
    transition: color 0.3s;
    &:hover {
      color: ${Color.lightGrey};
    }
  }
`;

export const LogoContainer = styled.div`
  font-weight: ${FontWeight.Bold};
  font-size: 20px;
  letter-spacing: 1px;
  margin-left: 20px;
`;

export const Logo = styled.img`
  margin-left: 20px;
`;
